import styled from "styled-components";

interface ModalProps {
  active?: boolean;
  visible?: boolean;
  windowHeight?: number;
}

export const Modal = styled.div<ModalProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw);
  height: calc(100vh + 100px);
  padding-bottom: 100px;
  z-index: 12000;
  overflow-x: hidden;
  overflow-y: hidden;
  background: #22222280 0% 0% no-repeat padding-box;
  display: ${({ active }) => (active ? "flex" : "none")};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  opacity: ${({ visible }) => (visible ? 1 : 0)};

  @media only screen and (max-width: 768px) {
    align-items: flex-end;

    ${({ windowHeight }) => (windowHeight ? `height: ${windowHeight}px;` : "")}
    padding-bottom: 0;
  }

  .caixa_container {
    transform: ${({ visible }) =>
      visible ? "translateY(0)" : "translateY(-100px)"};
    transition: all 0.5s;
  }

  transition: all 0.5s;
  p {
    margin: 0;
  }
`;

export const Container = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 3px #00000029;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  //padding: 24px;
  position: relative;
  width: 578px;

  @media only screen and (max-width: 768px) {
    max-width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding-bottom: 80px;
  }

  .modal_container_header {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 16px 16px #00000029;
    border-radius: 24px 24px 0px 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    padding-left: 24px;
    padding-right: 24px;

    .modal_container_header_title {
      text-align: left;
      font: normal normal 500 24px/32px Roboto;
      letter-spacing: 0px;
      color: #222222;
    }

    .modal_container_header_button {
      border-radius: 19px;
      background: transparent;
      height: 38px;
      width: 80px;
      text-align: center;
      font: normal normal 500 16px/21px Roboto;
      letter-spacing: 0px;
      color: #676767;
      text-transform: none;
    }
  }

  .modal_container_body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    .modal_container_body_user {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font: normal normal 500 15px/20px Roboto;
      letter-spacing: 0px;
      color: #222222;
      width: 100%;
      opacity: 1;
    }

    .modal_container_body_link {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      img {
        width: 20px;
        height: 10px;
        margin-right: 14px;
      }
      p {
        text-align: left;
        font: normal normal normal 13px/18px Roboto;
        letter-spacing: 0px;
        color: #1069d9;
        max-width: 391px;
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }

  .modal_container_block {
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px 16px 16px #00000029;
    border-radius: 24px;
    padding: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 24px;
    .modal_container_block_header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding-bottom: 16px;
      .modal_container_block_header_first {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .modal_container_block_header_first_circle {
          background: #e0e0e0 0% 0% no-repeat padding-box;
          border-radius: 12px;
          width: 24px;
          height: 24px;
          margin-right: 18px;
        }
        .modal_container_block_header_first_circle_selected {
          background: #ffffff 0% 0% no-repeat padding-box;
          border: 6px solid #28a745;
        }

        .modal_container_block_header_first_title {
          text-align: left;
          font: normal normal normal 16px/21px Roboto;
          letter-spacing: 0px;
          color: #222222;
        }
      }
      .modal_container_block_header_last {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .modal_container_block_header_last_item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          text-align: left;
          font: normal normal normal 13px/18px Roboto;
          letter-spacing: 0px;
          color: #222222;

          .modal_container_block_header_last_item_block {
            width: 16px;
            height: 16px;
            background: var(--300-e0e0e0) 0% 0% no-repeat padding-box;
            background: #e0e0e0 0% 0% no-repeat padding-box;
            border-radius: 4px;
            margin-right: 8px;
          }

          .modal_container_block_header_last_item_block_on {
            background: #28a745;
          }
        }
        .modal_container_block_header_last_item
          + .modal_container_block_header_last_item {
          margin-left: 24px;
        }
      }
    }
  }

  // min-width: 540px;
  .lp_close_button {
    border: 0;
    outline: 0;
    background: transparent;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 24px;
      height: 24px;
    }
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .lp_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    .lp_header_title {
      text-align: center;
      font: normal normal 600 16px/24px Poppins;
      letter-spacing: 0px;
      color: ${"#222222"};
      max-width: 180px;
    }
  }

  .lp_subtitle {
    text-align: center;
    align-self: center;
    font: normal normal normal 14px/18px Poppins;
    letter-spacing: 0px;
    color: ${"#676767"};
    max-width: 360px;
    margin-bottom: 56px;

    @media only screen and (max-width: 768px) {
      max-width: 100%;
    }
  }

  .lp_limpar_button {
    border: 0;
    outline: 0;
    background: #e8453e 0% 0% no-repeat padding-box;
    // box-shadow: -5px 5px 19px #28a7451a;
    border-radius: 16px;
    height: 48px;
    width: 420px;
    margin-bottom: 24px;
    text-align: center;
    font: normal normal 500 16px/25px Poppins;
    letter-spacing: 0px;
    color: #ffffff;

    @media only screen and (max-width: 768px) {
      max-width: 100%;
    }
  }

  .lp_cancel_button {
    border: 0;
    outline: 0;
    background: #ffffff 0% 0% no-repeat padding-box;
    // box-shadow: -5px 5px 19px #28a7451a;
    border-radius: 16px;
    height: 48px;
    width: 420px;
    text-align: center;
    font: normal normal 500 16px/25px Poppins;
    letter-spacing: 0px;
    color: ${"#676767"};

    @media only screen and (max-width: 768px) {
      max-width: 100%;
    }
  }
`;
